<template>
  <component
    :is="to ? 'router-link' : 'button'"
    :to="to || undefined"
    :class="cn(
      'shrink-0 whitespace-nowrap inline-flex items-center justify-center px-[12px] py-[4px] rounded-[8px] text-[#0A0A0A] text-[14px] transition-all duration-[150ms] cursor-pointer focus:outline-none select-none',
      computedIsActive
        ? 'bg-white shadow-[0px_1px_3px_0px_#0000001A] hover:text-[#0A0A0A] font-medium'
        : 'hover:bg-[#E5E5E5] hover:text-[#0A0A0A]'
    )"
    v-bind="to ? {} : {}"
    @click="!to && tabsState && tabsState.setActive(value)"
  >
    <slot />
  </component>
</template>

<script>
import { cn } from '../utils'

export default {
  name: 'TabItem',
  inject: {
    tabsState: { default: null },
  },
  props: {
    value: {
      type: [String, Number],
      default: null,
    },
    to: {
      type: [String, Object],
      default: null,
    },
    active: {
      type: Boolean,
      default: null,
    },
  },
  computed: {
    computedIsActive() {
      if (this.active !== null) return this.active
      if (this.tabsState) return this.tabsState.activeValue === this.value
      return false
    },
  },
  methods: {
    cn,
  },
}
</script>
